<template>
	<div class="container">
		<div class="main_box">
			<!--导航-->
			<navBox></navBox>
			<!--导航-->
			<!--banner-->
			<div class="banner_box">
				<img src="../../assets/img_h5/services/banner_1.webp"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				/>
				<div class="msg_box"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="400"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="tit">Contact Us</div>
					<div class="txt">
						Should you have any specific product or testing service requests, please contact us for ordering or partnership opportunities.
					</div>
				</div>
			</div>
			<!--banner-->
			<!--块1-->
			<div class="block_1">
				<div class="block_1_main">
					<div class="right">
						<contact></contact>
					</div>
					<div class="left">
						<div class="list_box">
							<div class="list_el"
								data-aos="fade-up"
								data-aos-duration="400"
								data-aos-delay="100"
								data-aos-offset="0"
								data-aos-once="true"
							>
								<div class="img">
									<img src="../../assets/img/contact/icon_1.webp" />
								</div>
								<div class="tit">
									USA Address: 8940 Kenamar Dr<br />
									San Diego, CA 92121<br />
									USA Phone: +1 (858) 999-1525
								</div>
							</div>
							<div class="list_el"
								data-aos="fade-up"
								data-aos-duration="400"
								data-aos-delay="200"
								data-aos-offset="0"
								data-aos-once="true"
							>
								<div class="img">
									<img src="../../assets/img/contact/icon_1.webp" />
								</div>
								<div class="tit">
									China Address: Room 302, Building 6, Yard 26<br />
									Yongwang West Road, Daxing District, Beijing<br />
									China Phone: +86 (010) 69390660
								</div>
							</div>
							<div class="list_el"
								data-aos="fade-up"
								data-aos-duration="400"
								data-aos-delay="300"
								data-aos-offset="0"
								data-aos-once="true"
							>
								<div class="img">
									<img src="../../assets/img/contact/icon_2.webp" />
								</div>
								<div class="tit">
									Email:<br />
									<!-- General: <a href="mailto:info@UCreagent.com">info@UCreagent.com</a><br />
									Sales: <a href="mailto:sales@UCreagent.com">sales@UCreagent.com</a><br />
									Tech Support: <a href="mailto:support@Jtests.com">support@Jtests.com</a><br />
									Ag, Ab, NC Membrane: <a href="mailto:AM@Jtests.com">AM@Jtests.com</a><br />
									Lab Testing: <a href="mailto:CLlA@Jtests.com">CLlA@Jtests.com</a> -->
									<a href="mailto:info@UCreagent.com">info@UCreagent.com</a><br />
									<a href="mailto:sales@UCreagent.com">sales@UCreagent.com</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--块1-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navBox from '@/component/h5/nav.vue'  //导航组件
import footerBox from '@/component/h5/footer.vue'  //版权组件
import contact from '@/component/h5/contact.vue'  //联系我们组件
import { UPURL } from '@/util/util.js';
export default {
	components:{
		navBox,
		footerBox,
		contact
	},
	data() {
		return {
			isLoading: true,  //界面loading
		}
	},
	created(){
		let that = this;
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	methods: {
		goHome() {
			this.$router.push('/');
		}
	}
}
</script>

<style lang="less" scoped>
.main_box{
	color: #000000;
	font-size: 14px;
	//块1
	.block_1{
		padding: 30px 20px;
		.block_1_main{
			width: 100%;
			margin: 0 auto;
			.left{
				padding: 50px 0 0 0;
				.list_box{
					.list_el{
						display: flex;
						padding-bottom: 30px;
						.tit{
							flex: 1;
							font-size: 18px;
							a{
								color: #006BB3;
								text-decoration: underline;
							}
						}
						.img{
							padding: 1px 10px 0 0;
							img{
								width: 24px;
								height: auto;
							}
						}
					}
				}
			}
			.right{}
		}
	}
	//banner
	.banner_box{
		position: relative;
		.msg_box{
			width: 100%;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			padding: 0 20px;
			text-align: center;
			.txt{
				font-size: 18px;
				color: #ffffff;
			}
			.tit{
				font-size: 36px;
				color: #ffffff;
			}
		}
		img{
			width: 100%;
		}
	}
}
</style>